import {FunctionComponent, TableHTMLAttributes} from 'react';
import {clsx} from 'clsx';
import {TableRow} from '@/components/table/table-body/row/row';
import {TABLE_THEME, TableTheme} from '@/constants/table';
import TableBody from './table-body';
import TableHeader from './table-header';

export interface TableData {
  headers: string[];
  body: TableRow[];
}

type HeaderProps = TableHTMLAttributes<HTMLTableElement> & {
  data: TableData;
  dataTestid: string;
  theme?: TableTheme;
};

const Table: FunctionComponent<HeaderProps> = ({data, dataTestid, theme = TABLE_THEME.PRIMARY}) => {
  return (
    <table
      data-testid={dataTestid}
      data-theme={theme}
      className={clsx(
        'w-full text-base',
        theme === TABLE_THEME.SECONDARY &&
          'border-separate border-spacing-0 overflow-hidden rounded-2 border border-grey-400',
      )}
    >
      <TableHeader headers={data.headers} theme={theme} />
      <TableBody rows={data.body} theme={theme} />
    </table>
  );
};

export default Table;
